import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// ----------------------------------------------------------------------

const SIXTY_MINUTES = 1000 * 60 * 60;

export const useCRMRecordStore = create(
  persist(
    (set) => ({
      crmRecordsIds: [],
      crmCurrentPosition: 0,
      crmLastUpdate: Date.now(),
      crmRecordType: '',
      crmSearchInput: '',
      crmSearchRecordValue: '',
      crmGridFilterModel: {},
      crmGridSortModel: [],
      setCRMRecordsIds: ({ records, recordType }) => set(state => ({ crmRecordsIds: records, crmCurrentPosition: 0, crmRecordType: recordType, crmSearchInput: state.crmSearchRecordValue === recordType ? state.crmSearchInput : '' })),
      setCRMCurrentPosition: ({ position }) => set({ crmCurrentPosition: position }),
      setCRMSearchInput: ({ inputValue, recordType }) => set({ crmSearchInput: inputValue, crmSearchRecordValue: recordType }),
      setCRMGridFilterModel: ({ quickList, filterModel, recordType }) => set({ crmGridFilterModel: { quickList, filterModel }, crmSearchRecordValue: recordType }),
      setCRMGridSortModel: ({ sortModel }) => set({ crmGridSortModel: sortModel }),
      setCRMNextStep: () => set(state => ({ crmCurrentPosition: state.crmCurrentPosition + 1, crmLastUpdate: Date.now() })),
      setCRMPrevStep: () => set(state => ({ crmCurrentPosition: state.crmCurrentPosition - 1, crmLastUpdate: Date.now() })),
      setCRMReset: () => set({ crmRecordsIds: [], crmCurrentPosition: 0, crmLastUpdate: Date.now(), crmRecordType: '', crmSearchInput: '', crmSearchRecordValue: '', crmGridFilterModel: {}, crmGridSortModel: [] }),
    }),
    {
      name: 'crm-record-storage-v1',
      getStorage: () => localStorage,
      onRehydrateStorage: () => (state) => {
        const now = Date.now();
        const last = state.crmLastUpdate;
        if (now - last > SIXTY_MINUTES) {
          state.setCRMReset();
        }
      }
    },
  ),
);
